const resources = {
    via: 'par'
};

module.exports = function getResource(label) {
    return resources[label];
};
